import {
  PARAGRAPH_ENGLISH_TEXT_KEY,
  PARAGRAPH_KAZAKH_TEXT_KEY,
  PARAGRAPH_RUSSIAN_TEXT_KEY,
} from '@esentai/core/features/campaigns/article/consts/layoutKeys';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import FieldDescription from '@/components/FieldDescription';
import TextField from '@/components/TextField';
import limits from '@/features/campaignCreatePage/EditPage/limits';

import { getName } from '../utils';

class ParagraphBlock extends Component {
  static propTypes = {
    Field: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    disabled: PropTypes.bool.isRequired,
  };

  render() {
    const { Field, index, disabled } = this.props;

    return (
      <Fragment>
        <FieldDescription desc="Тип блока «Абзац текста» позволяет вставить блок стандартного текста с количеством символов не более 500. Текст нельзя отформатировать и он будет вставляться одним абзацем. Поэтому, если вам надо вставить несколько абзацев подряд, просто добавьте еще один текстовый блок." />

        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Field
              disabled={disabled}
              Target={TextField}
              name={getName(index, PARAGRAPH_RUSSIAN_TEXT_KEY)}
              label="Текст абзаца"
              helperText="На русском"
              symbolsMax={limits.paragraph}
              rowMax={15}
              fullWidth
              multiline
            />
          </Grid>

          <Grid item xs={12}>
            <Field
              disabled={disabled}
              Target={TextField}
              name={getName(index, PARAGRAPH_ENGLISH_TEXT_KEY)}
              label="Текст абзаца"
              helperText="На английском"
              symbolsMax={limits.paragraph}
              rowMax={15}
              fullWidth
              multiline
            />
          </Grid>

          <Grid item xs={12}>
            <Field
              disabled={disabled}
              Target={TextField}
              name={getName(index, PARAGRAPH_KAZAKH_TEXT_KEY)}
              label="Текст абзаца"
              helperText="На казахском"
              symbolsMax={limits.paragraph}
              rowMax={15}
              fullWidth
              multiline
            />
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

export default ParagraphBlock;
